import React, { useState, useEffect } from "react";
import Select from "react-select";

const WarehouseMultiSelect = ({
  name,
  options,
  value,
  onChange,
  onBlur,
  isMulti = false,
  placeholder,
  isClearable,
  noOptionsMessage,
}) => {
  const [selectedOptions, setSelectedOptions] = useState(
    options.filter((option) => value?.includes(option.value)) || []
  );

  useEffect(() => {
    setSelectedOptions(
      options.filter((option) => value?.includes(option.value)) || []
    );
  }, [value, options]);

  return (
    <Select
      closeMenuOnScroll={(e) => {
        try {
          const target = e.target;
          if (
            !target ||
            !target.nodeType ||
            typeof target.closest !== "function"
          ) {
            return true;
          }
          const isMenuScroll =
            target.closest('[class*="MenuList"]') ||
            target.closest('[class*="menu"]');
          return !isMenuScroll;
        } catch (error) {
          return true;
        }
      }}
      isMulti={isMulti}
      name={name}
      id={name}
      options={options || []}
      menuPortalTarget={document.body}
      menuPosition="fixed"
      menuPlacement="auto"
      value={selectedOptions}
      onChange={(newSelectedOptions) => {
        const updated = newSelectedOptions && Array.isArray(newSelectedOptions)
          ? newSelectedOptions
          : [];
        const updatedValues = updated.map((opt) => opt.value);
        setSelectedOptions(updated);
        onChange(updatedValues);
      }}
      onBlur={onBlur}
      placeholder={placeholder}
      isSearchable
      isClearable={isClearable}
      closeMenuOnSelect={false}
      noOptionsMessage={noOptionsMessage}
      styles={{
        menu: (provided) => ({
          ...provided,
          maxHeight: "200px",
          overflowY: "auto",
        }),
        menuList: (provided) => ({
          ...provided,
          maxHeight: "200px",
          overflowY: "auto",
        }),
        control: (provided) => ({
          ...provided,
          color: "#5e667b",
        }),
        placeholder: (provided) => ({
          ...provided,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }),
      }}
    />
  );
};

export default WarehouseMultiSelect;